const name = "@sis-cc/dotstatsuite-sdmxjs";
const version = "10.1.0";
const engines = {
  node: ">=18.*"
};
const description = "SDMX library for JavaScript";
const author = "SISCC";
const license = "MIT";
const type = "module";
const repository = "https://gitlab.com/sis-cc/.stat-suite/dotstatsuite-sdmxjs";
const main = "./dist/cjs/index.js";
const module = "./dist/esm/index.mjs";
const sideEffects = false;
const files = [
  "dist"
];
const scripts = {
  build: "vite build",
  test: "vitest run --coverage",
  "test:watch": "vitest",
  lint: "eslint src --color",
  "lint:eslint": "eslint --ignore-pattern '!eslint.config.js'",
  "docs:lint": "documentation lint src/**/*.js",
  "docs:generate": "documentation build src/index.js --sort-order alpha --format md --output docs/api.md --markdown-toc false",
  "docs:build": "vitepress build docs",
  "docs:preview": "vitepress preview docs",
  docs: "node scripts/docs/before.js && yarn docs:generate && yarn docs:build && node scripts/docs/after.js"
};
const dependencies = {
  axios: "^1.7.7",
  "date-fns": "^2.16.1",
  qs: "^6.7.0",
  ramda: "^0.30.1"
};
const devDependencies = {
  "@eslint/compat": "^1.2.0",
  "@eslint/eslintrc": "^3.1.0",
  "@eslint/js": "^9.12.0",
  "@rollup/plugin-commonjs": "^28.0.1",
  "@rollup/plugin-node-resolve": "^15.3.0",
  "@vitest/coverage-v8": "^2.1.4",
  documentation: "^14.0.3",
  eslint: "^9.12.0",
  "eslint-config-prettier": "^9.1.0",
  "eslint-plugin-import": "^2.31.0",
  "eslint-plugin-prettier": "^5.2.1",
  globals: "^15.11.0",
  husky: "^2.1.0",
  prettier: "^3.3.3",
  "pretty-quick": "^4",
  vite: "^5.4.9",
  vitepress: "^1.4.1",
  vitest: "^2.1.4"
};
const husky = {
  hooks: {
    "pre-commit": "pretty-quick --staged"
  }
};
const meta = {
  name,
  version,
  engines,
  description,
  author,
  license,
  type,
  repository,
  main,
  module,
  sideEffects,
  files,
  scripts,
  dependencies,
  devDependencies,
  husky
};
export {
  author,
  meta as default,
  dependencies,
  description,
  devDependencies,
  engines,
  files,
  husky,
  license,
  main,
  module,
  name,
  repository,
  scripts,
  sideEffects,
  type,
  version
};
